// Autogenerated file
export const bidRefuelingServiceTypesEnum = {
    MultiGo: "MultiGo",
    Delkon: "Delkon",
    Str: "Str",
    MultiGo2: "MultiGo2",
    SolarFrps: "SolarFrps",
};
export const bidRefuelingServiceTypes = [
    { label: "MultiGo", value: "MultiGo" },
    { label: "DELKON", value: "Delkon" },
    { label: "СТР", value: "Str" },
    { label: "MultiGo 2", value: "MultiGo2" },
    { label: "Планировщик CARGO.RUN", value: "SolarFrps" },
];
